'use client'
import HeroCard from '@/components/Cards/HeroCard'
import LabelCard from '@/components/Cards/LabelCard'
import LifeCard from '@/components/Cards/LifeCard'
import { FilteredArticles, Heading } from '@/components/Common'
import { useNews } from '@/hooks/useNews'
import Image from 'next/image'
import Link from 'next/link'
import React from 'react'

const HealthySection = () => {
  const { allNews: healthyNews, isLoading: healthyLoading } = useNews({
    menuSlug: 'suc-khoe',
    size: 21,
  })
  const { allNews: lifeNews, isLoading: lifeLoading } = useNews({
    menuSlug: 'doi-song',
    size: 18,
  })
  return (
    <section className="container mt-4">
      <div className="grid grid-cols-12 gap-4">
        {/*-------------------------------------*/}
        <div className="col-span-12 lg:col-span-3">
          <Heading>Sức khoẻ</Heading>
          <div className="flex flex-col gap-4">
            {healthyLoading
              ? Array.from({ length: 10 }).map((_, index) => (
                  <HeroCard key={index} isLoading isImage={index === 0} />
                ))
              : healthyNews.map((news, index) => (
                  <HeroCard
                    key={news.id}
                    className="block border-b border-gray-300"
                    title={news.title}
                    categoryName={news.categoryName}
                    categoryId={news.categoryId}
                    imageUrl={news.imageUrl}
                    link={news.slug}
                    isImage={index === 0}
                  />
                ))}
          </div>
        </div>

        {/*-------------------------------------*/}
        <div className="col-span-12 lg:col-span-6">
          <Heading>Đời sống</Heading>
          {lifeLoading ? (
            <>
              <div className="animate-pulse">
                <div className="w-full h-[350px] bg-gray-300 rounded-lg mb-4"></div>{' '}
                {/* Skeleton for Image */}
                <div className="w-1/3 h-4 bg-gray-300 rounded-md mb-2"></div>{' '}
                {/* Skeleton for Category */}
                <div className="w-2/3 h-4 bg-gray-300 rounded-md"></div> {/* Skeleton for Title */}
              </div>
              <div className="divide-y divide-gray-300">
                {Array.from({ length: 8 }).map((_, index) => (
                  <LifeCard key={index} isLoading /> // Truyền isLoading đúng
                ))}
              </div>
            </>
          ) : (
            <>
              <article>
                <Link href={`/${lifeNews[0]?.slug}`}>
                  <div className="relative">
                    <Image
                      src={`${process.env.NEXT_PUBLIC_IMAGE_URL}${lifeNews[0]?.imageUrl}`}
                      alt={lifeNews[0]?.title || 'title'}
                      title={lifeNews[0]?.title}
                      width={300} // Adjust the width as needed
                      height={150} // Adjust the height as needed
                      sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 680px"
                      style={{ height: '350px' }}
                      className="w-full h-full object-cover"
                      priority
                      unoptimized
                    />
                    <LabelCard
                      categoryId={lifeNews[0]?.categoryId}
                      categoryName={lifeNews[0]?.categoryName}
                    />
                  </div>
                  {/* Tiêu đề */}
                  <div className="p-4">
                    <h3
                      className="text-black font-semibold text-center text-[18px] hover:text-primary"
                      title={lifeNews[0]?.title}
                    >
                      {lifeNews[0]?.title}
                    </h3>
                  </div>
                </Link>
              </article>
              <div className="divide-y divide-gray-300">
                {lifeNews.slice(1).map((news) => (
                  <LifeCard
                    key={news?.id}
                    title={news?.title}
                    description={news?.description}
                    imageUrl={news?.imageUrl}
                    link={news?.slug}
                    isLoading={false} // Đảm bảo không truyền isLoading khi đã có dữ liệu
                  />
                ))}
              </div>
            </>
          )}
        </div>

        {/*-------------------------------------*/}
        <div className="col-span-12 lg:col-span-3">
          <FilteredArticles />
        </div>
      </div>
    </section>
  )
}

export default HealthySection
